import React from 'react';
import Select from 'react-select';
import {fromJS} from 'immutable';
import {faultTypes} from '../utils.jsx';
import * as logistics from './logistics.jsx';

const ACTIONS = {
  LOADING: 'LOADING',
  INITIAL: 'INITIAL',
  EDIT_READER: 'EDIT_READER',
  TRANSFER: 'TRANSFER',
};

const BulkReaderAllocationChoice = {
  ALLOCATE: 'allocate',
  DEALLOCATE: 'deallocate'
};

class CardReadersPage extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      status: ACTIONS.LOADING,
      reader: undefined,
      business: undefined,
      allocationState: undefined,
      readerFulfilmentStates: undefined,
      readerLocations: undefined,
      readerStatuses: undefined,
      readerFulfilmentState: undefined,
      readerLocation: undefined,
      readerStatus: undefined,
      isEditable: false,
      isUsedSku: false,
      isRental: undefined,
      canAllocate: undefined,
      isTest: undefined,
      showLocationDetails: false,
      selectedBusinessId: undefined,
    };
  };

  componentWillMount() {
    this.loadReader();
    this.loadValidReaderAttributes();
  };

  setStateFromResponse(response, status) {
    this.setState({
      reader: response.data.reader,
      business: response.data.business,
      readerProduct: response.data.readerProduct,
      allocationState: response.data.allocationState,
      readerFulfilmentState: response.data.reader.trackingData.fulfilmentState,
      readerLocation: response.data.reader.trackingData.readerLocation,
      readerStatus: response.data.reader.trackingData.readerStatus,
      isRental: response.data.reader.isRental,
      isEditable: response.data.reader.isEditable,
      isUsedSku: response.data.reader.isUsed,
      canAllocate: response.data.reader.canAllocate,
      status: status,
      isTest: response.data.reader.isTest,
      physicalCondition: response.data.reader.returnData.physicalCondition
    });
  };

  // Setting RS reader ID query param
  setRSIDFromResponse(response) {
    if (response.data?.reader?.readerServiceId) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("readerServiceId", response.data.reader.readerServiceId)
      const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }
  }

  loadReader() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.props.readerUUID}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setStateFromResponse(response, ACTIONS.INITIAL);
        this.setRSIDFromResponse(response)
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  reloadReader() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.props.readerUUID}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setStateFromResponse(response, ACTIONS.INITIAL);
        this.scrollToElement("cardReadersHeader");
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  loadValidReaderAttributes(params='') {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/validReaderAttributes/${params}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setState({
          readerFulfilmentStates: response.data.readerFulfilmentStates.sort().map(state => { return {value: state, label: state.humanize()} }),
          readerLocations: response.data.readerLocations.sort().map(location => { return {value: location, label: location.humanize()} }),
          readerStatuses: response.data.readerStatuses.sort().map(status => { return {value: status, label: status.humanize()} })
        })
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  getValidReaderAttributesSearchParameters() {
    let params = {
      readerStatus: this.state.readerStatus,
      readerLocation: this.state.readerLocation,
      readerFulfilmentState: this.state.readerFulfilmentState
    };
    let searchParameters = Object.keys(params).filter(k => params[k] !== '');
    if (searchParameters.length > 0){
      return `?${searchParameters.map(k => k + '=' + params[k]).join('&')}`;
    }
    return '';
  };

  updateReaderAttributes() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/updateReaderAttributes`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        serialNumber: this.state.reader.serialNumber,
        readerStatus: this.state.readerStatus,
        readerFulfilmentState: this.state.readerFulfilmentState,
        readerLocation: this.state.readerLocation,
        isRental: this.state.isRental
      })
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.reloadReader();
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  onReaderAttributeChange (data, property) {
    this.setState({
      [property]: data.value,
    },() => this.loadValidReaderAttributes(this.getValidReaderAttributesSearchParameters()));
  };

  markReaderAsUsed() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.props.readerUUID}/markAsUsed`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        radio('showAlert').broadcast('info', `${response.message}: ${this.state.reader.serialNumber}`);
        this.setStateFromResponse(response, ACTIONS.INITIAL);
        this.scrollToElement("cardReadersHeader");
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  };

  markReaderAsTest() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.props.readerUUID}/markAsTest`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        radio('showAlert').broadcast('info', `${response.message}`);
        this.setStateFromResponse(response, ACTIONS.INITIAL);
        this.scrollToElement("cardReadersHeader");
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  };

  deallocateReaderFromFulfilment(fulfilmentId, readerId) {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/delete/inventory/fulfilments/${fulfilmentId}/items/${readerId}`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        radio('showAlert').broadcast('info', response.message);
        // We have a small delay here for a reload because inventory is the source of truth for fulfilment
        // allocation/deallocation, and fulfilment allocation changes need to sync across to RS
        setTimeout(() => {
          window.location.reload();
        }, 500);

      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  };

  deallocateReaderFromBusiness(deallocateBusiness) {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.props.readerUUID}/deallocate`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        deallocateBusiness: deallocateBusiness,
        deallocateFulfilment: false,
      })
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        radio('showAlert').broadcast('info', response.message);
        this.setStateFromResponse(response, ACTIONS.INITIAL);
        this.scrollToElement("cardReadersHeader");
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  };

  editReader() {
    this.loadValidReaderAttributes(this.getValidReaderAttributesSearchParameters());
    this.scrollToElement("cardReadersDetailsContainer");
    this.setState({status: ACTIONS.EDIT_READER});
  };

  saveReader() {
    this.updateReaderAttributes();
  };

  cancelReader() {
    this.loadValidReaderAttributes();
    this.loadReader();
  };

  resetReader() {
    this.setState({
      readerFulfilmentState: '',
      readerLocation: '',
      readerStatus: ''
    });
    this.loadValidReaderAttributes()
  };

  flickRentedSwitch() {
    this.setState({
      isRental: !this.state.isRental
    });
  };

  transferReader() {
    this.setState({status: ACTIONS.TRANSFER});
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState && prevState.status !== ACTIONS.TRANSFER && this.state.status === ACTIONS.TRANSFER) {
      this.scrollToElement("reader-transfer-container");
    }
  };

  render() {
    if(this.state.status !== ACTIONS.LOADING) {
      const isTest = this.state.isTest && this.state.isTest.toString() === 'true' ? 'Yes': 'No';
      return (
          <div className='cardReadersMainContainer'>
            {this.getHeader()}
            <DetailsContainer
                reader={fromJS(this.state.reader)}
                readerProduct={fromJS(this.state.readerProduct)}
                business={fromJS(this.state.business)}
                isTest={isTest}
            />
            <CheckBoxRow text='Is Rental:'
                         value={this.state.isRental}
                         onChange={() => this.flickRentedSwitch()}
                         isDisabled={this.state.status !== ACTIONS.EDIT_READER}
            />
            <DetailsSubContainer heading='Reader Tracking Data'
                                 rows={this.getReaderTrackingDataRows()}/>
            <DetailsSubContainer heading='Logistics/Finance Data'
                                 rows={this.getLogisticsFinanceDataRows()}/>
            {this.getBeingTransferredDataRows()}
            {this.getSaveCancelButtons()}
            {this.getAllocateReaderBlock()}
            {this.getTransferOwnershipBlock()}
          </div>
      );
    }
    return <div/>;
  };

  getHeader() {
    let idleScreenButton = <HeaderButton
        buttonText="Idle screen"
        buttonType="btn-info cardReadersHeaderButton"
        onPress={() => this.props.history ?
            this.props.history.push(`/logistics/card-readers/${this.props.readerUUID}/idleScreen/`) :
            window.location.assign(`/logistics/card-readers/${this.props.readerUUID}/idleScreen/`)}
    />;

    let markAsUsedButton = '';
    if (!this.state.isUsedSku && this.state.isEditable) {
      markAsUsedButton = <HeaderButton
          buttonText="Mark Used"
          buttonType="btn-info cardReadersHeaderButton"
          onPress={() => this.markReaderAsUsed()}
      />;
    }
    let markAsTestButton = '';
    if (!this.state.isTest) {
      markAsTestButton = <HeaderButton
          buttonText="Mark as Test"
          buttonType="btn-info cardReadersHeaderButton"
          onPress={() => this.markReaderAsTest()}
      />;
    }
    let deallocateButton = '';
    if (this.state.reader.linkData.fulfilmentId || this.state.business) {
      deallocateButton = <HeaderButton
          buttonText="Deallocate"
          buttonType="btn-warning cardReadersHeaderButton"
          onPress={() => {
            if(this.state.reader.linkData.fulfilmentId) {
              this.deallocateReaderFromFulfilment(this.state.reader.linkData.fulfilmentId, this.state.reader.readerServiceId)
            } else {
              this.deallocateReaderFromBusiness(!!this.state.business)
            }
          }}
      />;
    }
    let editButton = '';
    if (this.state.status === ACTIONS.INITIAL && this.state.isEditable) {
      editButton = <HeaderButton
          buttonText="Edit"
          buttonType="btn-primary cardReadersHeaderButton"
          onPress={() => this.editReader()}
      />;
    }
    let transferOfOwnershipButton = '';
    if (this.state.status === ACTIONS.INITIAL && this.props.isYocoLogisticsSuperAdmin){
      transferOfOwnershipButton = <HeaderButton
          buttonText="Transfer Ownership"
          buttonType="btn-primary cardReadersHeaderButton"
          onPress={() => this.transferReader()}
      />;
    }
    return(
        <header className='cardReadersHeader' >
          <h1>
            Card Reader
          </h1>
          <div className='cardReadersHeaderButtons'>
            {idleScreenButton}
            {markAsUsedButton}
            {markAsTestButton}
            {deallocateButton}
            {editButton}
            {transferOfOwnershipButton}
          </div>
        </header>
    );
  };

  getAllocationStateDisplayName(allocationState) {
    if (allocationState === 'allocating') {
      return 'Allocating â Waiting for card machine to be onboarded onto a Payment Processor'
    } else {
      return allocationState.humanize()
    }
  }

  toggleLocationDetails() {
    const showLocationDetails = !this.state.showLocationDetails;
    this.setState({
      showLocationDetails: showLocationDetails
    })
  }

  getReaderTrackingDataRows() {
    if (this.state.status === ACTIONS.EDIT_READER) {
      return(
          <div className='cardReadersEditContainer'>
            <div className='cardReadersEditRows'>
              <DetailsEditRow
                  text='Fulfilment State:'
                  value={this.state.readerFulfilmentState}
                  options={this.state.readerFulfilmentStates}
                  onChange={data => this.onReaderAttributeChange(data, 'readerFulfilmentState')}
              />
              <DetailsEditRow
                  text='Reader Location:'
                  value={this.state.readerLocation}
                  options={this.state.readerLocations}
                  onChange={data => this.onReaderAttributeChange(data, 'readerLocation')}
              />
              <DetailsEditRow
                  text='Reader Status:'
                  value={this.state.readerStatus}
                  options={this.state.readerStatuses}
                  onChange={data => this.onReaderAttributeChange(data, 'readerStatus')}
              />
            </div>
            <div className='cardReadersEditRowsReset'>
              <button
                  type="button"
                  className='btn-warning cardReadersNormalButton'
                  onClick={() => this.resetReader()}
              >
                Reset
              </button>
            </div>
          </div>
      );
    }

    let fulfilmentState = this.state.readerFulfilmentState ? this.state.readerFulfilmentState.humanize() : '';
    let readerLocation = this.state.readerLocation ? this.state.readerLocation.humanize() : '';
    let locationDetails = this.state.reader.trackingData.locationDetails ? JSON.stringify(this.state.reader.trackingData.locationDetails, null, 4) : '';
    let readerStatus = this.state.readerStatus ? this.state.readerStatus.humanize() : '';
    let physicalCondition = this.state.physicalCondition ? this.state.physicalCondition.humanize() : '';
    return (
        <ReaderTrackingDataRows
            fulfilmentState={fulfilmentState}
            readerLocation={readerLocation}
            locationDetails={locationDetails}
            showLocationDetails={this.state.showLocationDetails}
            toggleLocationDetails={() => this.toggleLocationDetails()}
            readerStatus={readerStatus}
            physicalCondition={physicalCondition}
        />
    );
  };

  getLogisticsFinanceDataRows() {
    const financeData = fromJS(this.state.reader).get('financeData');
    return (
        <LogisticsFinanceDataRows
            poNumber={financeData?.get('poNumber')}
            supplierInvoiceNumber={financeData?.get('supplierInvNumber')}
            receivedDate={financeData?.get('receivedDate')}
        />
    );
  };

  getBeingTransferredDataRows() {
    const reader = fromJS(this.state.reader);
    const isBeingTransferred = reader.get('transferData').get('isBeingTransferred');
    const oldBusiness = reader.get('oldBusiness');
    return (
        isBeingTransferred ?
            <DetailsSubContainer
                heading='Being Transferred Data'
                isRed={true}
                rows={
                  <div>
                    <DetailsRow
                        text='Being Transferred:'
                        value="True"/>
                    {this.getOldBusinessRow(oldBusiness)}
                  </div>}
            />
            : ''
    );
  };

  getOldBusinessRow(oldBusiness) {
    return (oldBusiness ?
            <DetailsRow
                text='Original Business:'
                value={<a
                    href={`/businesses/${oldBusiness.get('uuid')}/details`}>{oldBusiness.get('name')}</a>}/>
            : <DetailsRow text='Original Business:' value=''/>
    )
  }

  getSaveCancelButtons() {
    if(this.state.status===ACTIONS.EDIT_READER)
    {
      const isDisabled = !this.state.readerFulfilmentState || !this.state.readerLocation || !this.state.readerStatus;
      const saveTitle = isDisabled ? "Please fill the reader fulfilment state, location and status" : "";
      return(
          <div className='cardReadersSaveCancelButtons'>
            <button
                type="button"
                className='btn-primary cardReadersNormalButton'
                onClick={() => this.saveReader()}
                disabled={isDisabled}
                title={saveTitle}
            >
              Save
            </button>
            <button
                type="button"
                className='btn-danger cardReadersNormalButton'
                onClick={() => this.cancelReader()}
            >
              Cancel
            </button>
          </div>
      )
    }
  };

  getAllocateReaderBlock() {
    if (!this.state.readerLocation || this.state.readerLocation === '') {
      return '';
    }
    if (this.state.status !== ACTIONS.EDIT_READER && this.state.status !== ACTIONS.TRANSFER && this.state.canAllocate) {
      return <AllocateReaderBlock
          readerUUID={this.props.readerUUID}
          reader={this.state.reader}
          setStateFromResponse={(response, status) => this.setStateFromResponse(response, status)}
          scrollToElement={(element) => this.scrollToElement(element)}
      />
    }
    return '';
  };

  getTransferOwnershipBlock() {
    if (this.state.status === ACTIONS.TRANSFER) {
      return <TransferOwnershipBlock
      readerServiceId={this.state.reader.readerServiceId}
      userUUID={this.props.userUUID}
      previousBusiness={this.state.business}
      scrollToElement={(element) => this.scrollToElement(element)}
      cancelTransfer={() => this.setState({status: ACTIONS.INITIAL})}/>
    }
    return '';
  }

  scrollToElement(elementClassName) {
    document.getElementsByClassName(elementClassName)[0].scrollIntoView({
      behavior: 'smooth'
    });
  }
}

const HeaderButton = ({buttonText,buttonType,onPress}) => (
    <button
        type="button"
        className={buttonType}
        onClick={onPress}
    >
      {buttonText}
    </button>
);

const DetailsContainer = ({reader, readerProduct, business, isTest}) => (
    <div className='cardReadersDetailsContainer'>
      {reader.get('linkData').get('fulfilmentId') ?
          <DetailsRow text='Associated Fulfilment:'
                      value={
                        <a href={`/logistics/orders/fulfilments/${reader.get('linkData').get('fulfilmentId')}/`}> View fulfilment</a>
                      }
          />
          : null}

      {business ? <DetailsRow text='Business:'
                              value={
                                <a href={`/businesses/${business.get('uuid')}/details`}>{business.get('name')}</a>}
      /> : null}
      <DetailsRow text='Serial Number:'
                  value={reader.get('serialNumber', '')}
      />
      {readerProduct ? <DetailsRow text='Yoco SKU:'
                                   value={<a href={`/logistics/product-management/${readerProduct.get('uuid')}`}>{readerProduct.get('yocoSku')}</a>}
      /> : null}
      {readerProduct ? <DetailsRow text='Make:'
                                   value={readerProduct.get('make')}
      /> : null}

      <DetailsRow text='Created:'
                  value={admin.utils.formatDate(reader.get('created', ''))}
      />

      <DetailsRow text='Allocation Type:'
                  value={reader.get('allocationData').get('allocationType', '').humanize()}
      />
      {reader.get('allocationData').get('allocationType', '') === "transfer_of_ownership" ?
          <DetailsRow text='Source:'
                      value={
                        <UUIDLink uuid={reader.get('allocationData').get('source', '')}
                                  link={`/businesses/${reader.get('allocationData').get('source')}`}
                        />}
          />
          : reader.get('allocationData').get('allocationType', '') === 'order' ?
              <DetailsRow text='Source:'
                          value={
                            <UUIDLink uuid={reader.get('allocationData').get('source', '')}
                                      link={`/logistics/orders/${reader.get('allocationData').get('source')}`}
                            />}
              />
              :
              <DetailsRow text='Source:'
                          value={reader.get('allocationData').get('source', '').humanize()}
              />
      }
      <DetailsRow text='Is Test:'
                  value={isTest}
      />
      {reader.get('simCardLinks', '') ?
          <DetailsRow text='SIM Cards:'
                      value={
                        <ul>
                          {
                            reader.get('simCardLinks').map(s =>
                                (<li>{<a href={`/logistics/sim-cards/${s.get('id')}`}>{s.get('simNumber')} ({s.get('serviceProvider').humanize()})</a>}</li>))}
                        </ul>
                      }
          />: ''}
      <DetailsRow text='IMEI 1:'
                  value={reader.getIn(['imeiData', 'imei1'], '')}
      />
      <DetailsRow text='IMEI 2:'
                  value={reader.getIn(['imeiData', 'imei2'], '')}
      />
    </div>
);

const UUIDLink = ({uuid, link}) =>
    (
        <abbr title={uuid}>
          <a href={link}>{uuid.toString().substring(uuid.length - 6, uuid.length)}</a>
        </abbr>
    );

const DetailsSubContainer = ({heading,rows,isRed=false}) => (
    <div className={`cardReadersDetailsSubContainer ${isRed ? 'redBlock' : ''}`}>
      <header className='cardReadersDetailsSubContainerHeader'>
        <h2 className='cardReadersDetailsSubHeading'>
          {heading}
        </h2>
      </header>
      {rows}
    </div>
);

const createTable = ({terminals}) => {
  let table = [];
  if (!terminals || terminals.length === 0) {
    return table;
  }

  let header = <thead><tr><th>Created</th><th>Processing Bank</th><th>Terminal</th></tr></thead>;
  let body = [];
  for (let i = 0; i < terminals.length; i++) {
    let row = [];
    row.push(<td>{admin.utils.formatDate(terminals[i].created)}</td>);
    row.push(<td>{terminals[i].processingBank}</td>);
    row.push(<td>{terminals[i].terminalId}</td>);
    body.push(<tr>{row}</tr>);
  }
  table.push(header);
  table.push(<tbody>{body}</tbody>);
  return table;
};

const ReaderTrackingDataRows = ({
                                  fulfilmentState,
                                  readerLocation,
                                  locationDetails,
                                  showLocationDetails,
                                  toggleLocationDetails,
                                  readerStatus,
                                  physicalCondition,
                                }) => (
    <div>
      <DetailsRow text='Fulfilment State:' value={fulfilmentState} />
      <DetailsRow text='Reader Location:' value={readerLocation} />
      <DetailsRow text='Reader Status:' value={readerStatus} />
      {locationDetails ?
          <div>
            <DetailsRow text='Reader Location Details:'/>
            <button onClick={toggleLocationDetails}>{showLocationDetails ? 'Hide' : 'Show'}</button>
            {showLocationDetails ? <div><pre>{locationDetails}</pre></div> : ''}
          </div>
          : ''
      }
      <DetailsRow text='Physical Condition:' value={physicalCondition} />
    </div>
);

const LogisticsFinanceDataRows = ({
                                    poNumber,
                                    supplierInvoiceNumber,
                                    receivedDate
                                  }) => (
    <div>
      <DetailsRow text='PO Number:' value={poNumber} />
      <DetailsRow text='Supplier Invoice Number:' value={supplierInvoiceNumber} />
      <DetailsRow text='Received Date:' value={admin.utils.formatDate(receivedDate, false)} />
    </div>
);

const DetailsRow = ({text, value}) => (
    <div className='cardReadersDetailsRow'>
      <div className='cardReadersDetailsDescription'>
        {text}
      </div>
      <div className={`cardReadersDetailsValue ${getAllocationStateColor(value ? value.toString() : '')}`}>
        {value}
      </div>
    </div>
);

function getAllocationStateColor(allocationState) {
  if (allocationState.startsWith('Allocating')) {
    return 'amber'
  }
  if (allocationState === 'Allocated') {
    return 'green'
  }
  return ''
}

const CheckBoxRow = ({text, value, onChange, isDisabled}) => (
    <div className='cardReadersCheckboxContainer'>
      <div className='cardReadersCheckboxRow'>
        <div className='cardReadersCheckboxDescription'>
          {text}
        </div>
        <Switch
            isOn={value}
            handleToggle={() => onChange()}
            disabled={isDisabled}
        />
      </div>
    </div>
);

const Switch = ({ isOn, handleToggle, disabled }) => {
  return (
      <div className='cardReadersCheckboxValue'>
        <input
            checked={isOn}
            onChange={handleToggle}
            className="react-switch-checkbox"
            id={`react-switch-new`}
            type="checkbox"
            disabled={disabled}
        />
        <label
            style={{ background:  (disabled && isOn && '#6ba86b') || (disabled && '#DCDCDC') || (isOn && '#5cb85c')}}
            className="react-switch-label"
            htmlFor={`react-switch-new`}
        >
        <span
            style={{ background:  disabled && '#EEEEEE'}}
            className="react-switch-button"
        />
        </label>
      </div>
  );
};

const DetailsEditRow = ({text, value, options, onChange, size = 200, isSearchable = false}) => (
    <div className='cardReadersDetailsRow'>
      <div className='cardReadersDetailsDescription'>
        {text}
      </div>
      <Select
          styles={{control: (base) => ({...base, width: `${size}px`})}}
          onChange={onChange}
          options={options}
          value={options.filter(option => option.value === value)}
          placeholder={'Select an option...'}
          isSearchable={isSearchable}
          isClearable={false}
          // // Workaround for bug https://github.com/JedWatson/react-select/issues/439
          cacheAsyncResults={false}
      />
    </div>
);

class AllocateReaderBlock extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedBusiness: undefined,
      fulfilments: undefined
    };
  }

  componentWillMount() {
  }

  businessSelected(business) {
    this.setState({
      selectedBusiness: business
    });

    this.getFulfilments(business.uuid);
  }

  // NO-OP so that we can keep the forms library happy
  onChange(value) {}

  hasBusinessSelectionChanged() {
    return this.state.selectedBusiness !== undefined &&
        (!this.state.previousBusinessUUID || this.state.selectedBusiness.uuid !== this.state.previousBusinessUUID)
  }

  getFulfilments(businessUUID) {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/logistics/fulfilments?filters={"businessUUID":["${businessUUID}"]}`,
      method: 'GET'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.setState({
          fulfilments: response.data
        });
      } else {
        radio('showAlert').broadcast('warn', `Failed to retrieve readers for allocation (${response.status})`)
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  }

  render() {
    const businessUUID = this.state.selectedBusiness ? this.state.selectedBusiness.uuid : undefined;

    return (
        <div className='reader-allocation'>
          <header>
            <h1>Allocate Card Reader</h1>
          </header>

          <div className='reader-allocation-container'>
            <logistics.BusinessSelectField
                onFullOptionChanged={this.businessSelected.bind(this)}
            />
            <FulfilmentAllocationsTable
                readerUUID={this.props.readerUUID}
                reader={this.props.reader}
                businessUUID={businessUUID}
                fulfilments={this.state.fulfilments}
                setStateFromResponse={(response, status) => this.props.setStateFromResponse(response, status)}
                scrollToElement={(element) => this.props.scrollToElement(element)}
            />
            <AllocateToBusinessRow
                reader={this.props.reader}
                businessUUID={businessUUID}
                scrollToElement={(element) => this.props.scrollToElement(element)}
            />
          </div>
        </div>
    );
  }
}

class TransferOwnershipBlock extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedBusiness: this.props.previousBusiness,
    };
  }

  businessSelected(business) {
    this.setState({
      selectedBusiness: business
    });
  }

  cancelTransfer(){
    this.props.cancelTransfer()
    this.props.scrollToElement("cardReadersHeader");
  }

  transferOwnership() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/reader/readers/${this.props.readerServiceId}`,
      method: 'PATCH',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        isBeingTransferred: true,
        oldBusinessUUID: this.state.selectedBusiness.uuid,
        updatedByUUID: this.props.userUUID,
      })
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        radio('showAlert').broadcast('info', `Transfer successful`);
        window.location.reload();

      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  }

  render() {
    return(
        <DetailsSubContainer
        heading="Transfer Reader"
        rows={
          <div className='reader-transfer-container'>
            {this.state.selectedBusiness ? <DetailsRow text='Previous Business: ' value={this.state.selectedBusiness.name}/> : <div>
              <DetailsRow text={'Select the previous business:'}/>
              <logistics.BusinessSelectField onFullOptionChanged={this.businessSelected.bind(this)}/>
            </div>}
              <div className='cardReadersSaveCancelButtons'>
                <button
                    type="button"
                    disabled={!this.state.selectedBusiness}
                    className='btn-primary cardReadersNormalButton'
                    onClick={() => this.transferOwnership()}
                >
                  Transfer
                </button>
                <button
                    type="button"
                    className='btn-primary cardReadersNormalButton'
                    onClick={() => this.cancelTransfer()}
                >
                  Cancel
                </button>
              </div>
          </div>}
        />
    )
  }
}

class AllocateToBusinessRow extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
  }

  allocateToBusiness() {
    let url = `/api/readers/allocateToBusiness`;
    radio('showLoader').broadcast();
    $.ajax({
      url: url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        businessUUID: this.props.businessUUID,
        serialNumbers: [this.props.reader.serialNumber]
      })
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        radio('showAlert').broadcast('info', `Allocated reader ${this.props.reader.serialNumber}`);
        window.location.reload();
      } else {
        radio('showAlert').broadcast('danger', `Allocation failed (${response.status}): ${response.message}`);
        this.props.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.props.scrollToElement("cardReadersHeader");
    });
  }

  render() {
    return (
        <waffle.misc.Button
            label='Allocate to business'
            className='blue-background'
            disabled={!this.props.businessUUID}
            onClick={() => this.allocateToBusiness()}/>
    )
  }
}

class FulfilmentAllocationsTable extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
  }

  static getHeading() {
    return (
        <tr>
          <th>Created</th>
          <th>Status</th>
          <th>Delivery Reference</th>
          <th>View Details</th>
          <th>&nbsp;</th>
        </tr>
    );
  }

  allocateToFulfilment(fulfilmentId) {
    let url = `/api/inventory/fulfilments/${fulfilmentId}/items`;
    radio('showLoader').broadcast();
    $.ajax({
      url: url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        serial_number: this.props.reader.serialNumber,
      })
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 201) {
        radio('showAlert').broadcast('info', response.message);
        window.location.reload();
      } else {
        radio('showAlert').broadcast('danger', `Allocation failed (${response.status}): ${response.message}`);
        this.props.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.props.scrollToElement("cardReadersHeader");
    });
  }

  getRows() {
    return this.props.fulfilments.sort(
        function(a,b){
          return new Date(b.created_at) - new Date(a.created_at);
        }).map((fulfilment) => {
      return (<tr key={fulfilment.id}>
        <td>{admin.utils.formatDate(fulfilment.created_at)}</td>
        <td>{fulfilment.status.humanize()}</td>
        <td>{fulfilment.delivery_reference}</td>
        <td><a target='_blank' href={`/logistics/orders/fulfilments/${fulfilment.id}`}>View Details</a></td>
        <td>
          <waffle.misc.Button label='Allocate'
                              className='blue-background'
                              onClick={() => this.allocateToFulfilment(fulfilment.id)}/>
        </td>
      </tr>);
    });
  }

  render() {
    if (this.props.fulfilments && this.props.fulfilments.length > 0) {
      const heading = FulfilmentAllocationsTable.getHeading();
      const rows = this.getRows();
      return (
          <div className='reader-table-container'>
            <table className='reader-table'>
              <tbody>
              {heading}
              {rows}
              </tbody>
            </table>
          </div>
      );
    }
    // Return an empty div because we have neither a business selected nor any orders.
    return <div/>;
  }
}

class CardReaderAssessmentPage extends waffle.base.BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      status: ACTIONS.LOADING,
      reader: undefined,
      readerMake: undefined,
      readerProduct: undefined,
      assessmentDate: moment().startOf("day").add(5, "hours"),
      assessmentFaultType: undefined,
      assessmentResult: undefined,
      physicalCondition: undefined,
      physicalConditions: [ 'Poor', 'Good'].map(condition =>
      { return {value: condition, label: condition} }),
      assessmentFaultTypes: faultTypes(),
      assessmentResults: ["Faulty / Written Off", "Working / Second Hand", "Working / New"].map(result =>
      { return {value: result, label: result} })
    };
  };

  componentWillMount() {
    this.loadReaderDetails();
  };

  setStateFromResponse(response, status) {
    const reader = fromJS(response.data.reader);
    const assessmentDate = moment(reader.get('returnData').get('assessmentDate', moment().startOf("day").add(5, "hours")));
    const assessmentFaultType = reader.get('returnData').get('assessmentFaultType', '').humanize();
    const assessmentResult = reader.get('returnData').get('assessmentResult', '');
    const physicalCondition = reader.get('returnData').get('physicalCondition', '');
    this.setState({
      reader: response.data.reader,
      readerMake: response.data.readerMake,
      readerProduct: response.data.readerProduct,
      assessmentDate: assessmentDate,
      assessmentFaultType: assessmentFaultType,
      assessmentResult: assessmentResult,
      physicalCondition: physicalCondition,
      status: status
    });
  };

  loadReaderDetails() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.props.readerUUID}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setStateFromResponse(response, ACTIONS.INITIAL);
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  saveReaderAssessment() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/saveReaderAssessment`,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        serialNumber: this.state.reader.serialNumber,
        assessmentDate: this.state.assessmentDate,
        assessmentFaultType: this.state.assessmentFaultType,
        assessmentResult: this.state.assessmentResult,
        physicalCondition: this.state.physicalCondition,
      })
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 200) {
        this.reloadReader();
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  checkAndSaveAssessment() {
    if (!this.state.assessmentResult){
      radio('showAlert').broadcast('danger', "No Assessment Result Specified.");
    } else if (this.state.assessmentResult === "Faulty / Written Off" && !this.state.assessmentFaultType){
      radio('showAlert').broadcast('danger', "No Assessment Fault Type Specified.");
    } else if (this.state.assessmentResult === "Working / Second Hand" && !this.state.physicalCondition) {
      radio('showAlert').broadcast('danger', "No Physical Condition Specified.");
    } else {
      this.saveReaderAssessment()
    }
  }

  onAssessmentChange (data, property) {
    this.setState({
      [property]: data.value,
    });
    this.resetFaultTypeIfWorking(property, data);
  };

  onPhysicalConditionChange (data, property) {
    this.setState({
      [property]: data.value,
    });
  };

  resetFaultTypeIfWorking(property, data) {
    if (property === 'assessmentResult' && data.value !==
        'Faulty / Written Off') {
      this.setState({
        assessmentFaultType: undefined,
      });
    }
  }

  render() {
    if(this.state.status !== ACTIONS.LOADING) {
      return (
          <div className='cardReadersMainContainer'>
            <AssessmentDetailsContainer
                reader={fromJS(this.state.reader)}
                readerProduct={fromJS(this.state.readerProduct)}/>
            <DetailsSubContainer heading='Reason For Return'
                                 rows={this.getReasonForReturnData()}/>
            <DetailsSubContainer heading='Warehouse Assessment'
                                 rows={this.getAssessmentRows()}/>
          </div>
      );
    }
    return <div/>;
  };

  getReasonForReturnData() {
    const reader = fromJS(this.state.reader);
    const replacementDate = admin.utils.formatDate(reader.get('returnData').get('replacementDate', ''), false);
    const replacementType = reader.get('returnData').get('replacementType', 'None').humanize();
    const faultType = reader.get('returnData').get('faultType', 'None');
    return(
        <ReasonForReturnRows
            replacementDate={replacementDate}
            replacementType={replacementType}
            faultType={faultType}
        />
    );
  };

  getAssessmentRows() {
    return(
        <div className='cardReadersEditContainer'>
          <div className='cardReadersEditRows'>
            <DetailsDateRow
                text='Assessment Date:'
                value={this.state.assessmentDate}
                onChange={this.datePicked.bind(this)}
            />
            <DetailsEditRow
                text='Assessment Result:'
                value={this.state.assessmentResult}
                options={this.state.assessmentResults}
                onChange={data => this.onAssessmentChange(data, 'assessmentResult')}
                size={250}
            />
            {(this.state.assessmentResult === "Faulty / Written Off") ? <DetailsEditRow
                text='Fault Type:'
                value={this.state.assessmentFaultType}
                options={this.state.assessmentFaultTypes}
                onChange={data => this.onAssessmentChange(data, 'assessmentFaultType')}
                size={250}
                isSearchable={true}
            /> : <div/>}

            {(this.state.assessmentResult == "Working / Second Hand") ? <DetailsEditRow
                text='Physical Condition'
                value={this.state.physicalCondition}
                options={this.state.physicalConditions}
                onChange={data => this.onPhysicalConditionChange(data, 'physicalCondition')}
                size={250}
            /> : <div/>}

            {this.getSaveButton()}
          </div>
        </div>
    );
  };

  datePicked(incomingMoment) {
    let date = incomingMoment.add(5, "hours");
    this.setState({
      assessmentDate: date
    });
  }

  getSaveButton() {
    return(
        <div className='cardReadersSaveCancelButtons'>
          <button
              type="button"
              className='btn-primary cardReadersNormalButton'
              onClick={() => this.checkAndSaveAssessment()}
          >
            Save
          </button>
        </div>
    )
  };

  scrollToElement(elementClassName) {
    document.getElementsByClassName(elementClassName)[0].scrollIntoView({
      behavior: 'smooth'
    });
  }
}

const AssessmentDetailsContainer = ({reader, readerProduct}) => (
    <div className='cardReadersDetailsContainer'>
      <header className='cardReadersDetailsSubContainerHeader'>
        <h2 className='cardReadersDetailsSubHeading'>
          Reader Details
        </h2>
      </header>
      <DetailsRow text='Serial Number:'
                  value={reader.get('serialNumber', '')}
      />
      {readerProduct ? <DetailsRow text='Yoco SKU:'
                                   value={<a href={`/logistics/product-management/${readerProduct.get('uuid')}`}>{readerProduct.get('yocoSku')}</a>}
      /> : null}
      {readerProduct ? <DetailsRow text='Make:'
                                   value={readerProduct.get('make')}
      /> : null}
    </div>
);

const ReasonForReturnRows = ({replacementDate, replacementType, faultType}) => (
    <div>
      <DetailsRow text='Replacement Created:' value={replacementDate}/>
      <DetailsRow text='Replacement Type:' value={replacementType}/>
      <DetailsRow text='Fault Type:' value={faultType} />
    </div>
);

const DetailsDateRow = ({text, value, onChange}) => (
    <div className='cardReadersDetailsRow'>
      <div className='cardReadersDetailsDescription'>
        {text}
      </div>
      <misc.CalendarButton className='cardReadersDetailsCalendarButton'
                           date={value}
                           dateChanged={onChange}
      />
    </div>
);

class CardReaderAdditionalDetailsPage extends waffle.base.BaseComponent{
  constructor(props) {
    super(props);
    this.state = {
      coreReader: undefined,
      reader: undefined,
      serialNumber: undefined,
      status: ACTIONS.LOADING,
      allocationState: undefined,
      lastConnectedDeviceIdentifier: undefined,
      terminals: undefined,
    }
  };
  componentWillMount() {
    this.loadReader();
  };

  loadReader() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.props.readerUUID}`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setSerialNumberFromResponse(response, ACTIONS.INITIAL);
        this.loadBySerialNumber();
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  setSerialNumberFromResponse(response, status) {
    const reader = fromJS(response.data.reader);
    this.setState({
      reader: reader,
      serialNumber: reader.get('serialNumber'),
      status: status
    });
  };
  

  loadBySerialNumber() {
    radio('showLoader').broadcast();
    $.ajax({
      url: `/api/readers/${this.state.serialNumber}/serialNumber`,
      method: 'GET'
    }).done((response) => {
      if (response.status === 200) {
        this.setStateFromResponse(response, ACTIONS.INITIAL);
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
        this.scrollToElement("cardReadersHeader");
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
      this.scrollToElement("cardReadersHeader");
    });
  };

  setStateFromResponse(response, status) {
    this.setState({
      coreReader: response.data.reader,
      allocationState: response.data.reader.allocationState,
      lastConnectedDeviceIdentifier: response.data.reader.lastConnectedDeviceIdentifier,
      terminals: response.data.reader.terminals,
      status: status,
    });
  };

  getAllocationStateDisplayName(allocationState) {
    if (allocationState === 'allocating') {
      return 'Allocating â Waiting for device to be onboarded onto a Payment Processor'
    } else {
      return allocationState.humanize()
    }
  }

  render() {
    if(this.state.status !== ACTIONS.LOADING) {
    return (
      <div className='cardReadersMainContainer'>
        <header className='cardReadersHeader'><h1>Additional Details</h1></header>
        <DetailsSubContainer heading='Hardware Revision:'
                             rows={<DetailsRow text='Hardware Revision:'
                    value={this.state.reader.get('hardwareRevision', '')}/>}
        />
        <DetailsSubContainer
            heading='Connection Data'
            rows={this.getConnectionData()}
        />
      </div>
    );
  }
  return <div/>
};

  getConnectionData() {
    const allocationState = this.state.allocationState ? this.getAllocationStateDisplayName(this.state.allocationState) : '';
    const lastConnectedDeviceIdentifier = this.state.lastConnectedDeviceIdentifier ? this.state.lastConnectedDeviceIdentifier.humanize() : '';
    const terminals = this.state.terminals;
    return(
      <ConnectionDataRows
          allocationState={allocationState}
          lastConnectedDeviceIdentifier={lastConnectedDeviceIdentifier}
          terminals={terminals}
      />
    );
  }

  scrollToElement(elementClassName) {
    document.getElementsByClassName(elementClassName)[0].scrollIntoView({
      behavior: 'smooth'
    });
  }
}

const ConnectionDataRows = ({
  allocationState,
  lastConnectedDeviceIdentifier,
  terminals,
}) => (
  <div>
    <DetailsRow text='Allocation state:' value={allocationState} />
    <DetailsRow text='Last Connected Device:' value={
      <UUIDLink uuid={lastConnectedDeviceIdentifier}
        link={`/devices/${lastConnectedDeviceIdentifier}`} />
    } />
    <DetailsRow text='Terminals:' value={
      <table>{createTable({ terminals })}</table>
    } />
  </div>
);

class BulkReaderAllocationPage extends waffle.base.BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      serialNumbers: [''],
      selectedBusiness: undefined,
      allocationChoice: BulkReaderAllocationChoice.ALLOCATE
    }
  }

  updateSerialNumberRow(input, index) {
    const serialNumbers = this.inputToSerialNumbers(input);
    const newSerialNumbers = this.state.serialNumbers;
    for (const sn of serialNumbers) {
      newSerialNumbers[index] = sn;
      index++
    }
    if (serialNumbers.length > 0 && newSerialNumbers.length > 0 && newSerialNumbers[newSerialNumbers.length - 1] !== '') {
      this.setState({
        serialNumbers: [...newSerialNumbers, '']
      })
    } else {
      this.setState({
        serialNumbers: newSerialNumbers
      })
    }
  }

  inputToSerialNumbers(input, separatorIndex = 0) {
    const serialNumberSeparators = [', ', '; ', ',', ';', ' ', '/n'];
    if (separatorIndex > serialNumberSeparators.length - 1) {
      return [input]
    }
    const separator = serialNumberSeparators[separatorIndex];
    const serialNumbers = input.split(separator);
    if (serialNumbers.length === 1) {
      return this.inputToSerialNumbers(input, separatorIndex + 1)
    }
    return serialNumbers
  }

  removeSerialNumberRow(index) {
    const newSerialNumbers = this.state.serialNumbers;
    newSerialNumbers.splice(index, 1);
    this.setState({serialNumbers: newSerialNumbers})
  }

  serialNumberRow(serialNumber, index) {
    const key = "row-" + index;
    return (
        <div key={key}>
          <input
              id={key}
              value={serialNumber}
              onChange={(event) => this.updateSerialNumberRow(event.target.value, index)}
              placeholder={'Enter serial number'}
              className='serialNumberInput'
          />
          {!(index === this.state.serialNumbers.length - 1 && this.state.serialNumbers[index] === '') ?
              <span title='Remove Row' className='removeSerialNumberRowButton' onClick={() => this.removeSerialNumberRow(index)}> <i
                  className={"fa fa-times fa-lg"}/></span>
              : ''}
        </div>
    )
  }

  clearSerialNumbers() {
    this.setState({
      serialNumbers: ['']
    })
  }

  getSerialNumbersTable() {
    const infoTitle = `You may paste a whole list of serial numbers at once`
    const clearTitle = `Clear Serial Numbers`
    return (
        <div>
          <p>{this.state.serialNumbers.filter(sn => sn !== '').length} {"serial numbers"}</p>
          <span title={infoTitle}>
            <i className={"fa fa-info-circle"}/>
          </span>
          <div className='cardReaderSerialNumbersContainer'>
            <div className='cardReaderSerialNumbersTable'>
              <div>
                {this.state.serialNumbers.map((serialNumber, index) => this.serialNumberRow(serialNumber, index))}
              </div>
            </div>
            <div className='serialNumbersClearButton'>
              <button
                  type={'button'}
                  className='btn-primary cardReadersNormalButton'
                  title={clearTitle}
                  onClick={this.clearSerialNumbers.bind(this)}>
                Clear all
              </button>
            </div>
          </div>
        </div>
    )
  }

  bulkAllocateCardReaders() {
    const serialNumbers = this.state.serialNumbers.filter(sn => sn !== '');
    if (serialNumbers.length === 0) {
      radio('showAlert').broadcast('danger', `Please enter at least 1 'serial number'.`)
    } else if (serialNumbers.length > 200) {
      radio('showAlert').broadcast('danger', 'Too many rows. You may only update up to 200 readers at a time.')
    } else if (!this.state.selectedBusiness && this.state.allocationChoice === BulkReaderAllocationChoice.ALLOCATE) {
      radio('showAlert').broadcast('danger', 'Please select a business for allocation.')
    } else {
      const url = this.state.allocationChoice === BulkReaderAllocationChoice.ALLOCATE ? `/api/reader/businesses/${this.state.selectedBusiness.uuid}/readers` : '/api/reader/readers/bulkDeallocateFromBusiness'
      radio('showLoader').broadcast();
      $.ajax({
        url: url,
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: this.buildReaderAllocationPayload(serialNumbers)
      }).done((response) => {
        radio('hideLoader').broadcast();
        if (response.status === 200) {
          radio('showAlert').broadcast('success', `${response.message || 'Success'}`)
        } else {
          radio('showAlert').broadcast('danger', `${response.message}`)
        }
      }).fail((_, textStatus) => {
        radio('hideLoader').broadcast();
        radio('showAlert').broadcast('danger', textStatus)
      })
    }
  }

  buildReaderAllocationPayload(serialNumbers) {
    return JSON.stringify({
      serialNumbers: serialNumbers,
      updatedByUUID: this.props.user_uuid,
    })
  }

  businessSelected(business) {
    this.setState({
      selectedBusiness: business
    });
  }

  allocationChoiceSelected(allocationAction) {
    this.setState({
      allocationChoice: allocationAction.target.value
    });
  }

  render() {
    return (
        <div className='cardReadersMainContainer'>
          <header className='cardReadersHeader'>
            <h1>
              {'Bulk allocate rental readers'}
            </h1>
          </header>
          <div className='cardReadersDetailsContainer'>
            <div className={'cardReaderColourInfoBox'}>
              <ul>
                <li>This tool allows allocating multiple rental card readers to a business or deallocating multiple rental readers from any linked business.</li>
                <li>Please ensure the readers you list have the status of "Working". This can be edited directly on each readers detail page in Admin.</li>
                <li>Only update a maximum of 200 readers at a time.</li>
                <li>Please allow sufficient time after submitting for the changes to take effect.</li>
                <li>Note that readers changed using this tool will automatically be marked as rental readers.</li>
                <li>If you are experiencing problems with the tool please reach out on #ip-logistics-requests and we will assist you.</li>
              </ul>
            </div>
            <DetailsSubContainer
                heading={'Serial Numbers'}
                rows={this.getSerialNumbersTable()}
            />
            <DetailsSubContainer
                heading={'Bulk Action'}
                rows={
                  <div onChange={this.allocationChoiceSelected.bind(this)}>
                    <label><input type="radio" id="allocation" name="allocationChoice" value={BulkReaderAllocationChoice.ALLOCATE} defaultChecked={true}/> Allocate</label>
                    <label><input type="radio" id="deallocation" name="allocationChoice" value={BulkReaderAllocationChoice.DEALLOCATE}/> Deallocate</label>
                  </div>}
            />
            {this.state.allocationChoice === 'allocate' && <DetailsSubContainer
                heading={'Business selection'}
                rows={
                  <logistics.BusinessSelectField
                      onFullOptionChanged={this.businessSelected.bind(this)}
                  />
                }/>}
            <div className={"cardReaderColourInfoBox"}>
              {`Readers ${this.state.serialNumbers.join(', ')} will be deallocated from any associated businesses`}
              {this.state.allocationChoice === BulkReaderAllocationChoice.ALLOCATE && ` and be allocated to business: ${this.state.selectedBusiness?.name || "<no business selected>"}`}
            </div>
            <div className={"cardReaderBlankInfoBox"}>
              <button
                  type="button"
                  onClick={this.bulkAllocateCardReaders.bind(this)}
                  className='btn-primary cardReadersNormalButton'>
                Submit
              </button>
            </div>
          </div>
        </div>
    )
  }
}

module.exports = {
  CardReadersPage,
  CardReaderAssessmentPage,
  BulkReaderAllocationPage,
  CardReaderAdditionalDetailsPage
};
